import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { ProjectService } from "../shared/project/project.service";
import { DataService } from "../shared/network/data.service";
import { NotificationService } from "../shared/notificaton.service";
import { CardHelper } from "./cardHelper";
import { BaseCardsComponent } from "./base-cards-component";
import { FcstWalkTab, MainFcstWalkModel } from "../shared/project/cards/fcst-walk-model";
import { DriverType } from "../shared/project/driver-types/driver-type";
import { Card, FcstWalkCardType } from "../shared/project/cards/card";
import { FcstCardsMultiSelectMode } from "./multiselect-state";

@Component({
    templateUrl: './main-fcst-walk.component.html',
    styleUrls: ['./cards.component.scss']
})
export class MainFcstWalkComponent extends BaseCardsComponent implements OnInit {
    DriverType: typeof DriverType = DriverType;   //hack for enum to be available in the template
    FcstWalkCardType: typeof FcstWalkCardType = FcstWalkCardType;
    FcstCardsMultiSelectMode: typeof FcstCardsMultiSelectMode = FcstCardsMultiSelectMode;
    
    projectId: string;
    loading: boolean = true;
    showNavigator: boolean = false;
    model: MainFcstWalkModel;
    seqMode: boolean = true;
    selectedTabIx: number = undefined;
    xlsxDownloadLink: string;
    public multiSelectMode: FcstCardsMultiSelectMode = FcstCardsMultiSelectMode.None;

    story: string;

    constructor(private activatedRoute: ActivatedRoute, private router: Router,
        private dataService: DataService, private notifier: NotificationService) {
        super();
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if (projectId) {
                this.projectId = projectId;
                this.dataService.get<MainFcstWalkModel>('processing/GetMainFcstWalk/' + projectId).then(res => {
                    console.log(res);
                    if (res == null) {
                        this.notifier.showError("No forecast adjustments made");
                        this.router.navigateByUrl(`cards?projectId=${this.projectId}`);
                    }
                    this.loadModel(res);
                    this.loading = false;
                });
            }
        });
    }

    private loadModel(model: MainFcstWalkModel) {
        this.model = model;
        this.createXlsxDownLoadLink();
        this.turnOffMultiSelect();
        if (model.selectedTabIx !== null && model.selectedTabIx !== undefined) {
            this.loadTab(model.selectedTabIx);
        } else {
            this.loadMainTab();
        }
    }

    private loadMainTab() {
        this.varianceModel = this.model.varianceModel;
        this.loadWaterfallItems(this.model.varianceModel.cards, [], undefined);
        this.calcOutcomeCtxs();
        this.selectedTabIx = undefined;
    }

    private loadTab(tIx: number) {
        let tab = this.model.tabs[tIx];
        this.varianceModel = tab.varianceModel;
        this.loadWaterfallItems(tab.varianceModel.cards, [], undefined);
        this.calcOutcomeCtxs();
        this.selectedTabIx = tIx;
    }

    async undo() {
        if (this.loading || (this.model && !this.model.undoAvailable)) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.dataService.post<MainFcstWalkModel>('processing/UndoMainFcstWalk', {
                projectId: this.projectId,
                loadMainFcstWalkModel: true,
            });
            this.loadModel(model);
            if (history.state.returnTabIx) {
                this.tabClick(history.state.returnTabIx);
            }
        } finally {
            this.loading = false;
        }
    }

    async redo() {
        if (this.loading || (this.model && !this.model.redoAvailable)) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.dataService.post<MainFcstWalkModel>('processing/RedoMainFcstWalk', {
                projectId: this.projectId,
                loadMainFcstWalkModel: true,
            });
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    public setSeqMode(val: boolean): void {
        this.seqMode = val;
       /* this.loadWaterfallItems(this.cards, this.outOfScopeCards, this.balanceCard);
        for (let card of this.cards) {
            let name = card.selectedDiagram.name;
            card.selectedDiagram = (val ? card.altViewSeq.diagramSeries : card.altViewTot.diagramSeries).find(s => s.name == name);
        }*/
    }

    public quillClick(event: MouseEvent) {
       /* const target = event.target as HTMLElement;
        let classes = target.getAttribute('class');

        if (target.tagName === 'A' && target.hasAttribute('href') && classes == 'ql-preview') {
            event.preventDefault();
            
            const href = target.getAttribute('href');
            console.log('href=' + href);

            const url = decodeURIComponent(href);
            console.log('url=' + url);

            if (this.isInternalNgRoute(url)) {
                this.router.navigateByUrl(href);
            } else {
                window.open(url, '_blank');
            }
        }

        console.log('WYSIWYG story: ' + this.story);*/
    }

    public async explodeCard(cardIx: number, tabIx: number | undefined) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let path: number[];
            if (tabIx === undefined) {
                path = [ cardIx ];
            } else {
                path = [ cardIx, ...this.model.tabs[tabIx].path];
            }
            let model = await this.dataService.post<MainFcstWalkModel>('processing/ExplodeFcstWalkTab', {
                projectId: this.projectId,
                cardPath: path,
            });
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    public closeTab(tabIx: number) {
        this.model.tabs.splice(tabIx, 1);
        this.dataService.post<MainFcstWalkModel>('processing/CloseFcstWalkTab', {
            projectId: this.projectId,
            tabIx: tabIx,
        });
        if (tabIx == this.model.selectedTabIx) {
            this.loadMainTab();
        }
    }

    public async removeCard(card: Card) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.dataService.post<MainFcstWalkModel>('processing/RemoveFcstCards', {
                projectId: this.projectId,
                cardPaths: [ card.cardPath ],
            });
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    private async removeCards(cardIndexes: number[]) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let cardPaths = [];
            for (let i = 0; i < cardIndexes.length; ++i) {
                cardPaths.push(this.varianceModel.cards[cardIndexes[i]].cardPath);
            }
            let model = await this.dataService.post<MainFcstWalkModel>('Processing/RemoveFcstCards', {
                projectId: this.projectId,
                cardPaths: cardPaths,
            });
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    public async collapseMult(card: Card) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let model = await this.dataService.post<MainFcstWalkModel>('Processing/CollapseMults', {
                projectId: this.projectId,
                cardPaths: [ card.cardPath ],
            });
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    private async collapseMults(cardIndexes: number[]) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let cardPaths = [];
            for (let i = 0; i < cardIndexes.length; ++i) {
                cardPaths.push(this.varianceModel.cards[cardIndexes[i]].cardPath);
            }
            let model = await this.dataService.post<MainFcstWalkModel>('Processing/CollapseMults', {
                projectId: this.projectId,
                cardPaths: cardPaths,
            });
            this.loadModel(model);
        } finally {
            this.loading = false;
        }
    }

    public mainTabClick() {
        this.loadMainTab();
    }

    public tabClick(tIx: number) {
        this.loadTab(tIx);
    }
    
    private createXlsxDownLoadLink() {
        if (!this.model) {
            return;
        }
        let link = `${this.dataService.getBaseUrl()}/Processing/DownloadXlsx?projectId=${this.projectId}`;
        this.xlsxDownloadLink = link;
    }

    public turnOffMultiSelect() {
        this.multiSelectMode = FcstCardsMultiSelectMode.None;
        if (this.varianceModel && this.varianceModel.cards) {
            for (let card of this.varianceModel.cards) {
                card.markedForBulkAddToParent = false;
                card.markedForBulkRemove = false;
            }
        }
    }

    public toggleMultiSelect() {
        if (this.multiSelectMode === FcstCardsMultiSelectMode.None) {
            this.multiSelectMode = FcstCardsMultiSelectMode.Undecided;
        } else {
            this.multiSelectMode = FcstCardsMultiSelectMode.None;
        }
    }

    public markForBulkRemoveClick(card: Card) {
        if (card.markedForBulkRemove) {
            card.markedForBulkRemove = false;
            if (!this.anyCardIsMarkedForBulkRemove()) {
                this.multiSelectMode = FcstCardsMultiSelectMode.Undecided;
            }
        } else if (!this.anyCardIsMarkedForBulkCollapse()) {
            card.markedForBulkRemove = true;
            this.multiSelectMode = FcstCardsMultiSelectMode.Remove;
        }
    }

    public markForBulkCollapseClick(card: Card) {
        if (card.markedForBulkCollapse) {
            card.markedForBulkCollapse = false;
            if (!this.anyCardIsMarkedForBulkRemove()) {
                this.multiSelectMode = FcstCardsMultiSelectMode.Undecided;
            }
        } else if (!this.anyCardIsMarkedForBulkCollapse()) {
            card.markedForBulkCollapse = true;
            this.multiSelectMode = FcstCardsMultiSelectMode.Collapse;
        }
    }

    private anyCardIsMarkedForBulkRemove() {
        return !!this.varianceModel.cards.find(c => c.markedForBulkRemove);
    }

    private anyCardIsMarkedForBulkCollapse() {
        return !!this.varianceModel.cards.find(c => c.markedForBulkCollapse);
    }

    public async applyBulkOperation() {
        if (this.anyCardIsMarkedForBulkCollapse()) {
            let indexes = [];
            for (let i = 0; i < this.varianceModel.cards.length; ++i) {
                if (this.varianceModel.cards[i].markedForBulkCollapse) {
                    indexes.push(i);
                }
            }
            await this.collapseMults(indexes);
        } else if (this.anyCardIsMarkedForBulkRemove()) {
            let indexes = [];
            for (let i = 0; i < this.varianceModel.cards.length; ++i) {
                if (this.varianceModel.cards[i].markedForBulkRemove) {
                    indexes.push(i);
                }
            }
            await this.removeCards(indexes);
        } else {
            this.turnOffMultiSelect();
        }
    }

}